import HeaderDefault from '@/components/_core/ui/header/index.vue';
import MenuSidebarDefault from '~/components/_core/ui/menu-sidebar/index.vue';

import { mapGetters } from 'vuex';

export default {
  name       : 'AppLayout',
  components : {
    HeaderDefault,
    MenuSidebarDefault
  },
  props: {
    source     : String,
    statusMini : {
      type    : Boolean,
      default : false
    }
  },
  head() {
    return {
      title         : this.headTitle,
      titleTemplate : `%s :: ${process.env.APPLICATION_TITLE}`
    };
  },
  data: () => ({
    expandOnHover : false,
    type          : 'authenticated'
  }),
  created() {
    console.warn('This layout is deprecated. Please upgrade to _core/default');
  },
  computed: {
    ...mapGetters({
      showContent: '_core/auth/isAuthenticated' && '_core/auth/hasCurrentRole'
    })
  }
};
